import { ListaMediaSocials } from './styles'

const Socials = () => (
  <ListaMediaSocials>
    <li>
      <a
        href="http://www.linkedin.com/in/eliass-gomes/"
        target="_blank"
        rel="noreferrer"
      >
        <i className="bi bi-linkedin"></i>
      </a>
    </li>
    <li>
      <a href="http://github.com/eliassgo" target="_blank" rel="noreferrer">
        <i className="bi bi-github"></i>
      </a>
    </li>
  </ListaMediaSocials>
)

export default Socials
